import EmblaCarousel, { EmblaOptionsType } from 'embla-carousel';
import ClassNames from 'embla-carousel-class-names';
// import AutoHeight from 'embla-carousel-auto-height';
import { addPrevNextBtnsClickHandlers } from './arrow-buttons';
import { addDotBtnsAndClickHandlers } from './dot-buttons';
import '../css/embla.css';

const options: EmblaOptionsType = {
  align: 'center',
  loop: true,
  skipSnaps: false
};

document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    document
      .querySelectorAll('[id^="embla__carousel-"]')
      .forEach((emblaNode) => {
        const viewportNode = <HTMLElement>(
          emblaNode.querySelector('.embla__viewport')
        );
        const prevBtnNode = emblaNode.querySelector(
          '.embla__button--prev'
        ) as HTMLElement | null;
        const nextBtnNode = emblaNode.querySelector(
          '.embla__button--next'
        ) as HTMLElement | null;
        const dotsNode = <HTMLElement>(
          emblaNode.querySelector('.embla__dots')
        );
        const emblaApi = EmblaCarousel(viewportNode, options, [
          /* AutoHeight(), */ ClassNames()
        ]);

        const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
          emblaApi,
          prevBtnNode,
          nextBtnNode
        );
        const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
          emblaApi,
          dotsNode
        );

        emblaApi.on('destroy', removePrevNextBtnsClickHandlers);
        emblaApi.on('destroy', removeDotBtnsAndClickHandlers);
      });
  }, 0);
});
